const adviceDetailReducer = (state, {action, payload}) => {
    switch (action)
    {
        case 'initAdvice':
            return payload
        case 'addToFavorite':
            return { ...state, isFavorite: true }
        case 'removeFromFavorite':
            return { ...state, isFavorite: false }
        default:
            return state
    }

}

export {adviceDetailReducer}
